import { useSidebar } from "@nocios/presentation-kit";
import setCurrentPage from "src/Utils/setCurrentPage";
import Config from "src/Constants/Config";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import "./index.sass";

const HeaderCenter = () => {
  const { showSidebar, setShowSidebar } = useSidebar();

  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  return (
    <div className="header-center">
      <div className="header-center-circle" onClick={() => (window.location.href = Config.HOMEPAGE)}>
        <svg style={{ width: "var(--width-12)" }} xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
          <path
            d="M0.0253906 13.1851V4.68506L6.02539 0.435059L12.0254 4.68506V13.1851H7.52539V8.22673H4.52539V13.1851H0.0253906Z"
            fill="black"
          />
        </svg>
      </div>
      <div className={`header-center-circle ${currentPage === 1 ? "disabled" : ""}`} onClick={() => setCurrentPage(1)}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" style={{ width: "var(--width-18)" }} viewBox="0 0 1920 1920">
          <path
            d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0"
            fillRule="evenodd"
          />
        </svg>
      </div>
      <div className="header-center-circle" onClick={() => setShowSidebar(!showSidebar)}>
        <svg style={{ width: "var(--width-24)" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M4 18C3.71667 18 3.47934 17.904 3.288 17.712C3.09667 17.52 3.00067 17.2827 3 17C2.99934 16.7173 3.09534 16.48 3.288 16.288C3.48067 16.096 3.718 16 4 16H20C20.2833 16 20.521 16.096 20.713 16.288C20.905 16.48 21.0007 16.7173 21 17C20.9993 17.2827 20.9033 17.5203 20.712 17.713C20.5207 17.9057 20.2833 18.0013 20 18H4ZM4 13C3.71667 13 3.47934 12.904 3.288 12.712C3.09667 12.52 3.00067 12.2827 3 12C2.99934 11.7173 3.09534 11.48 3.288 11.288C3.48067 11.096 3.718 11 4 11H20C20.2833 11 20.521 11.096 20.713 11.288C20.905 11.48 21.0007 11.7173 21 12C20.9993 12.2827 20.9033 12.5203 20.712 12.713C20.5207 12.9057 20.2833 13.0013 20 13H4ZM4 8C3.71667 8 3.47934 7.904 3.288 7.712C3.09667 7.52 3.00067 7.28267 3 7C2.99934 6.71733 3.09534 6.48 3.288 6.288C3.48067 6.096 3.718 6 4 6H20C20.2833 6 20.521 6.096 20.713 6.288C20.905 6.48 21.0007 6.71733 21 7C20.9993 7.28267 20.9033 7.52033 20.712 7.713C20.5207 7.90567 20.2833 8.00133 20 8H4Z"
            fill="black"
          />
        </svg>
      </div>
    </div>
  );
};

export default HeaderCenter;
